import React, { PureComponent } from 'react';
import { message, Icon } from 'antd';
import { DefaultRegisterForm } from 'td-auth-component';
import './Register.css';

class Register extends PureComponent {
  onValidate = errorString => {
    message.error(errorString);
  };

  onSendCodeStart = () => {};

  onRegisterStart = () => {};

  onRegisterSuccess = data => {
    message.success('注册成功！');
    this.props.history.replace('/login');
  };

  onRegisterFail = errorString => {
    message.error(errorString);
  };
  handleBack = () => {
    this.props.history.goBack();
  };
  render() {
    return (
      <div className="register-page">
        <div className="content">
          <div className="skew-back">
            <div className="welcome">
              <span className="back">
                <Icon onClick={this.handleBack} type="left" />
              </span>
              <span>欢迎注册</span>
            </div>
            <DefaultRegisterForm
              onValidate={this.onValidate}
              onSendCodeStart={this.onSendCodeStart}
              onRegisterStart={this.onRegisterStart}
              onRegisterSuccess={this.onRegisterSuccess}
              onRegisterFail={this.onRegisterFail}
              addonBefore={{
                username: <div className="username-addon">+86</div>,
                code: null,
                password: null,
                confirmPassword: null
              }}
              registerParams={{
                scope: 'read',
                client_id: 'ebcFinanceLease',
                client_secret: 'TTk5SFE4',
                register_type: 'phone'
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/pages/auth/Register/Register.js